import clsx from 'clsx'
import {FC, PropsWithChildren} from 'react'
import {HeaderProps} from 'react-table'
import {ClassifiedPost} from '../../core/_models'

type Props = {
  className?: string
  title?: string
  tableProps: PropsWithChildren<HeaderProps<ClassifiedPost>>
}
const CustomHeader: FC<Props> = ({className, title, tableProps}) => {
  return (
    <th
      {...tableProps.column.getHeaderProps()}
      className={clsx(className)}
      style={{cursor: 'pointer'}}
    >
      {title}
    </th>
  )
}

export {CustomHeader}

